import { z } from 'zod';
import { SelectFieldParamsSchema } from './selectfield';
import { InitialUIElement } from '../initial-ui-element';
import { CommonOption } from '../common/option';

export const LOCALE_PICKER_FIELD_ELEMENT_TYPE = 'localepickerfield' as const;
export const LocalePickerFieldElementType = z.literal(LOCALE_PICKER_FIELD_ELEMENT_TYPE);

export const LocalePickerFieldParamsSchema = SelectFieldParamsSchema.extend({
  options: z.array(CommonOption),
});

export type TLocalePickerFieldParams = z.infer<typeof LocalePickerFieldParamsSchema>;

export const LocalePickerFieldElementSchema = InitialUIElement.extend({
  element: LocalePickerFieldElementType,
  params: LocalePickerFieldParamsSchema,
});
